export var STAT_TYPE = /* @__PURE__ */ ((STAT_TYPE2) => {
  STAT_TYPE2["FLOW"] = "flow";
  STAT_TYPE2["PERFORMANCE"] = "performance";
  STAT_TYPE2["EVENT"] = "event";
  STAT_TYPE2["CONSENT"] = "consent";
  return STAT_TYPE2;
})(STAT_TYPE || {});
export var FLOW_STATS_ATTRIBUTION_CAUSE_TYPE = /* @__PURE__ */ ((FLOW_STATS_ATTRIBUTION_CAUSE_TYPE2) => {
  FLOW_STATS_ATTRIBUTION_CAUSE_TYPE2["COMBINED"] = "combined";
  FLOW_STATS_ATTRIBUTION_CAUSE_TYPE2["ROOT"] = "root";
  FLOW_STATS_ATTRIBUTION_CAUSE_TYPE2["PROXIMATE"] = "proximate";
  return FLOW_STATS_ATTRIBUTION_CAUSE_TYPE2;
})(FLOW_STATS_ATTRIBUTION_CAUSE_TYPE || {});
export var FLOW_STATS_WEBSITE_ATTRIBUTION_CAUSE_TYPE = /* @__PURE__ */ ((FLOW_STATS_WEBSITE_ATTRIBUTION_CAUSE_TYPE2) => {
  FLOW_STATS_WEBSITE_ATTRIBUTION_CAUSE_TYPE2["COMBINED"] = "combined";
  FLOW_STATS_WEBSITE_ATTRIBUTION_CAUSE_TYPE2["MESSAGE"] = "message";
  FLOW_STATS_WEBSITE_ATTRIBUTION_CAUSE_TYPE2["CLICK"] = "click";
  return FLOW_STATS_WEBSITE_ATTRIBUTION_CAUSE_TYPE2;
})(FLOW_STATS_WEBSITE_ATTRIBUTION_CAUSE_TYPE || {});
export var FLOW_STATS_SAMPLE_TYPE = /* @__PURE__ */ ((FLOW_STATS_SAMPLE_TYPE2) => {
  FLOW_STATS_SAMPLE_TYPE2["START"] = "start";
  FLOW_STATS_SAMPLE_TYPE2["WEBSITE_ORDER"] = "website_order";
  FLOW_STATS_SAMPLE_TYPE2["TEXT_ORDER"] = "text_order";
  FLOW_STATS_SAMPLE_TYPE2["MESSAGE"] = "message";
  FLOW_STATS_SAMPLE_TYPE2["CLICK"] = "click";
  FLOW_STATS_SAMPLE_TYPE2["OPTOUT"] = "optout";
  return FLOW_STATS_SAMPLE_TYPE2;
})(FLOW_STATS_SAMPLE_TYPE || {});
